// OVP rendering
import { trackers } from '@rmm/error-tracker';
import ovpRenderer from './utils/ovpRenderer';
import domContentLoaded from './utils/domContentLoaded';
import initLoggerForAmp from './logger';
import { canRunAds } from './utils/ovpUtils';

const { SimpleErrorTracker } = trackers;

window.ovpPlayers = window.ovpPlayers || {};

// Logger for AMP pages
if ('amp' === window.NXSTdata.content.pageType) {
  initLoggerForAmp();
}

// Pollyfilling hasOwnProperty for window
// eslint-disable-next-line max-len
window.hasOwnProperty = (prop) => Object.prototype.hasOwnProperty.call(window, prop);

// OVP player initialized (if VideoPlayer exists)
// Init event
const IS_LOGGING_ONLY_LEAD_MEDIA = window.loggingSettings?.onlyLeadMedia;
const errorTracker = new SimpleErrorTracker('Loads OVP renderer', 100, {
  id: IS_LOGGING_ONLY_LEAD_MEDIA ? 'player-lead-media' : 'general-task',
  position: IS_LOGGING_ONLY_LEAD_MEDIA ? 'Lead Media' : 'general-task',
  renderGroup: 'Initialization within WP',
});

// Detects adblocker based on Ima sdk
window.isAdBlockerActive = ! canRunAds();

document.addEventListener('click', () => {
  sessionStorage.setItem('video_user_interacted', '1');
});

// Triggers ovp renderer
try {
  ovpRenderer();
  domContentLoaded(() => {
    ovpRenderer();
  });
  errorTracker.sendSuccess();
} catch (e) {
  errorTracker.sendError(e, 1);
}
